<div
    class="badge fx-row fx-layout-align-start-center"
    [class.header]="headerStyle"
    [routerLink]="['/admin', 'iam', 'organizations', 'id', globalSearchOrganization?.tenantId]"
>
    <!-- session icon -->
    <mat-icon svgIcon="c-customer"></mat-icon>

    <div class="info fx-column fx-flex">
        <span class="content" [attr.title]="globalSearchOrganization.name | ceCustomerPrivacy: 'org'">
            {{ globalSearchOrganization.name | ceCustomerPrivacy: 'org' }}
        </span>
        <span i18n="Organization badge|Badge header">Organization</span>
    </div>
</div>
